import React, { useContext, useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import {
  PaginationContext,
  ListWithPagination,
  PaginationProvider,
  Flex,
  Text,
} from 'dash-ui';
import { useGetBrokerGuestUserQuery } from 'gql/generated.graphql';

import GuestUserListItem from './components/GuestUserListItem/GuestUserListItem';

const StyledList = styled(ListWithPagination)`
  & > div:first-child {
    padding: 0;
    border: none;
  }
  & > div:last-child {
    justify-content: center;
  }
`;

const Header = styled(Flex)`
  @media ${({ theme }) => theme.devices.mobile} {
    display: none;
  }
`;

const ReactionByGuestUserView = () => {
  const { t } = useTranslation(['common', 'pages']);
  const { setTotal, state, getRefetchProps, setPerPage } =
    useContext(PaginationContext);
  const pagination = getRefetchProps(state);
  const [activeGuestUsers, setActiveGuestUsers] = useState('');

  const { data, loading } = useGetBrokerGuestUserQuery({
    variables: {
      pagination,
    },
  });

  const { guestUsers, totalCount } = useMemo(
    () => ({
      guestUsers: data?.getBrokerGuestUser.collection || [],
      totalCount: data?.getBrokerGuestUser.totalCount || 0,
    }),
    [data]
  );

  useEffect(() => {
    setTotal(totalCount);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [totalCount]);

  useEffect(() => {
    setPerPage(12);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Flex flexDirection="column" w="100%">
      <Header
        p={3}
        w="100%"
        flex={1}
        flexDirection="row"
        justifyContent="space-between"
      >
        <Flex flex={2}>
          <Text>{t('tables:reactions:nameOrId')}</Text>
        </Flex>
        <Flex flex={2}>
          <Text>{t('tables:reactions:email')}</Text>
        </Flex>
        <Flex flex={1}>
          <Text>{t('tables:reactions:properties')}</Text>
        </Flex>
        <Flex flex={1}>
          <Text>{t('tables:reactions:reactions')}</Text>
        </Flex>
      </Header>
      <StyledList
        paginationProps={{
          nextButtonLabel: t('common:labels.next'),
          previousButtonLabel: t('common:labels.previous'),
        }}
        listProps={{
          w: '100%',
          loading,
          loadingProps: { bgColor: 'inherit' },
          data: guestUsers,
          flexDirection: 'column',
          gap: 8,
          mb: 2,
        }}
      >
        {(item) => (
          <PaginationProvider>
            <GuestUserListItem
              guestUser={item}
              activeGuestUsers={activeGuestUsers}
              setActiveGuestUsers={setActiveGuestUsers}
            />
          </PaginationProvider>
        )}
      </StyledList>
    </Flex>
  );
};

export default ReactionByGuestUserView;
